import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/admissions/elder-registration";

export const Route = createFileRoute("/admin/_admissions/elder-registration")({
  component: Page,
});
